"use strict";

window.isIE11 = {};
window.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

// SVG helper
svg4everybody();

var
currDate = new Date(),
showRequest = function(formData, jqForm,options){
  var queryString = $.param(formData);
  return true;
},
showResponse = function(responseText,statusText,xhr,$form){
  if(statusText == 'success') {
    alert('Ваш вопрос получен. Уведомление об ответе вы получите на указанную вами электронную почту');
  }else{
    alert('Ошибка при отправке сообщения');
  };
},

// Навигация по якорям
scrollCatalog = function (id,delay){
  // console.log(id);
  var idOffsetTop = Math.round( $(id).offset().top ),
    bodyOffsetTop = $('body').offset().top,
    paddingTop = 45,
    headerHeight = ( $('header').length )? $('header').height() : 0,
    navMainHeight = ( $('.navbar').length )? $('.navbar').height() : 0,
    $chScrollPositions = Math.round( idOffsetTop - paddingTop + headerHeight - navMainHeight );

  // console.log($chScrollPositions);

  if (delay) { delay = 300; }

  $('html,body').delay(delay)
    .animate({ scrollTop: $chScrollPositions }, 400, 'swing');

  if( !$('.navbar .navbar-toggle').hasClass('collapsed') ){
    $('.navbar .navbar-toggle').addClass('collapsed');
    $('#losterin-navbar-top-collapse').collapse('hide');
  }

  return true;
},

buildTab = (function (){
  var tablist = $('.wheretobuy-tablist'),
    tabNav = tablist.find('.nav'),
    tabContent = tablist.find('.tab-content'),
    pharmacy,
    pharmacyHtml;

  function init() {
    _clearData();

    $.when(_getData())
      .done(function(){
        // console.log(pharmacy);
        $.when(_build(pharmacy))
          .done(function(){
            _setActive('moskva');
          });
      });

    _setUpListners();
  }

  function _setUpListners() {}

  function _clearData() {
    tabNav.html('');
    tabContent.html('');
  }

  function _setActive(alias) {
    var
      nav = tabNav.find('li:eq(0)'),
      tab = $('#' + nav.find('a').attr('aria-controls'));

    if ( $('#' + alias).length == 0 ) { alias = false; }

    if (alias) {
      nav = tabNav.find('[aria-controls="'+alias+'"]').parents('li');
      tab = $('#' + alias);
    }

    nav.addClass('active').find('a').attr('aria-expanded','true');
    tab.addClass('active');
  }

  function _build(list) {
    list.forEach(function(item, i, arr) {
      var tabContentBuild = '';

      tabNav.append('<li><a href="#' + item.cityalias + '" aria-controls="' + item.cityalias + '" role="tab" data-toggle="tab" title="' + item.city + '">' + item.city + '</a></li>');

      tabContentBuild = '<div role="tabpanel" class="tab-pane" id="' + item.cityalias + '">';
      tabContentBuild += '<div class="col-xs-10 col-xs-offset-1">';
      tabContentBuild += '<h4 class="text-center"><b>' + item.city + '</b></h4>';

      if ( item.descr != "" ){
        tabContentBuild += '<p>' + item.descr + '</p>';
      }

      if ( item.online != "" ){
        tabContentBuild += '<br><p><b>В интернет аптеках:</b></p>';

        item.online.forEach(function(item, i, arr) {
          tabContentBuild += '<p><b>' + item.title + '</b>, '
          + (( item.linksite != "" )? '<a rel="nofollow" href="//' +item.linksite+'" target="_blank">' +item.linksite+' <i class="fa fa-external-link"></i></a>' : '' )
          + '</p>';
        });
      }

      if ( item.network != "" ){
        tabContentBuild += '<br><p><b>В аптечных сетях:</b></p>';

        item.network.forEach(function(item, i, arr) {
          tabContentBuild += '<p><b>' + item.title + '</b> '
          + (( item.phone != "" )? '<br>' +item.phone : '' )
          + ' ' + (( item.linkmap != "" )? '<br><a rel="nofollow" href="' +item.linkmap+'" target="_blank">адресa аптек на карте <i class="fa fa-external-link"></i></a>' : '' ) + '</p>';
        });
      }

      if ( item.points != "" ){
        tabContentBuild += '<br><p><b>В аптеках:</b></p>';

        item.points.forEach(function(item, i, arr) {
          tabContentBuild += '<p><b>' + item.title + '</b> '
          + (( item.address != "" )? '<br>' +item.address : '' ) + ' '
          + (( item.phone != "" )? '<br>' +item.phone : '' ) + ' '
          + (( item.linkmap != "" )? '<br><a rel="nofollow" href="' +item.linkmap+'" target="_blank">адрес аптеки на карте <i class="fa fa-external-link"></i></a>' : '' ) + '</p>';
        });

      }

      tabContentBuild += '</div><div class="clearfix"></div>';
      tabContentBuild += '</div>';
      tabContent.append(tabContentBuild);
    });
  }

  function _getData() {
    return $.get('/block-list-pharmacy_1.json', "json")
    .done(function( data ) {
      pharmacy = data.pharmacy;
    });
  }

  function _getDataHtml() {
    return $.get('/block-list-pharmacy.html', "html")
    .done(function( data ) {
      pharmacyHtml = data;
    });
  }

  return {
    init: init
  };

})(), // => END module buildTab

trackGAEvent = function(category, label, action){
  action = (typeof action === "undefined") ? 'click' : action;
  if(typeof ga == 'function') {
    ga('send', 'event', category, action, label, { 'hitCallback': function(){} });
  }
  if(typeof gtag == 'function') {
    gtag('event', action, {
      // 'send_to': 'GA_MEASUREMENT_ID',
      'event_category': category,
      'event_label': label
    });
  }

  console.log('trackGAEvent', label);
  return true;
},

trackOutboundLink = function(url){
  trackGAEvent('outbound', url);
},

reachGoal = function(_ID, _TARGET){
  if (typeof ym == "function") {
    ym(_ID, 'reachGoal', _TARGET);
  }
  // console.log('reachGoal', _TARGET);
  return true;
},

calcPrice = function(self) {
  var quantityProd = 0;
  if(self.val() != ''&&!(/[a-zA-Z]/.test(self.val()))){
    quantityProd = parseInt(self.val());
  };
  var singleProdPrice = $('.total-price .cost').data('price'),
    totalPrice = quantityProd*singleProdPrice;
  $('.total-price .cost').html(totalPrice);
}

,copyToBuffer = function($inputID) {
  // Get the text field
  var copyText = document.getElementById($inputID);

  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices

   // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);

  // Alert the copied text
  alert("Скопировано в буфер обмена");
}

;$(function(){
  if(!$.cookie('cookieAgree')) {
    // var $cookieAgree = $('<div id="cookieAgree"><button type="button" class="close"><i class="fa fa-times" aria-hidden="true"></i></button><p class="text-center"><b>Продолжая использовать веб-сайт, вы соглашаетесь с использованием файлов cookie <br class="d-none d-md-inline">и принимаете следующие <a href="#" data-toggle="modal" data-target="#modalTermsOfUse">Условия&nbsp;использования</a>.</b></p><p class="text-small">Этот веб-сайт использует cookie для вашей быстрой и удобной работы с ним. <br>Вы можете изменить настройки cookie-файлов в своём браузере, но функционал сайта в таком случае может быть ограничен.</p></div>');
    var $cookieAgree = $('<div id="cookieAgree" style="display: block;"><button type="button" class="close" title="Соглашаюсь"><i class="fa fa-times" aria-hidden="true"></i></button><span>Мы используем cookie для быстрой и удобной работы сайта. Используя наш сайт, вы принимаете <a href="#" data-toggle="modal" data-target="#modalTermsOfUse">условия обработки персональных данных</a>.</span></div>');
    $('body').append($cookieAgree);
    $('#cookieAgree').show(800);
    $('#cookieAgree').on('click', '.close', () => {
      $('#cookieAgree').hide(300);
      $.cookie('cookieAgree', 1);
    });
  }

  $('._goals').on('click', function(){
    var
      _ymid = $(this).data('ymid'),
      _ymt = $(this).data('ymt'),
      _gac = $(this).data('gacategory'),
      _gal = $(this).data('galabel');
    if (typeof _ymt === "undefined") {} else {
      reachGoal(_ymid, _ymt);
      // console.log('reachGoal',_ymt);
    }
    if (typeof _gal === "undefined") {} else {
      trackGAEvent(_gac, _gal);
      // console.log('trackGAEvent',_gal);
    }
  });

  $('.copyToBuffer').on('mousedown', function(){
    var _this = $(this);
    copyToBuffer(_this.attr('id'));
  });

  if ( $('h2').length ) {
    $('h2[id]').each(function(){
      var _item = $(this),
        _link = $('<a href="#'+_item.attr('id')+'" class="__link" style="display:none;"><small><i class="fa fa-link"></i></small></a>');
      // _item.append('&nbsp;').append(_link);
      _item.on("mouseenter mouseleave", function(){
        _item.find('a.__link').toggle();
      });
    });
  }

  if ($('.wheretobuy-tablist ._selectize').length > 0) {
    var $currPage = document.location.pathname,
      $wtbPage = $currPage.split('/')[1],
      $wtbList = $('.wheretobuy-tablist [role="tablist"]'),
      $wtbSelect = $('<select id="wtbSelect" class=".form-control col-sm-8 col-sm-offset-2" onChange="if (this.value) window.location.href=this.value"></select>');

    $('.wheretobuy-tablist [role="tablist"]').hide().after($wtbSelect);

    $wtbList.find('li').each(function(){
      var self = $(this),
        $value = self.find('a').attr('href');

      if (self.find('a').attr('href').split('#')[1]) {
        $value = '/'+ $wtbPage +'/'+ self.find('a').attr('href').split('#')[1];
      }

      if (self.find('a').attr('href').split('#')[1] == 'moskva') {
        $value = '/'+ $wtbPage;
      }

      $wtbSelect.append('<option value="'+ $value +'" '+ (($value == $currPage || ($currPage == '/'+$wtbPage && self.find('a').attr('href').split('#')[1] == 'moskva') )? 'selected': '') +'>'+ self.text() +'</option>');
    });

    $wtbSelect.selectize({
      create: false,
      highlight: true,
      sortField: 'asc',
      createOnBlur: true,
      placeholder: 'Введите название города или области'
    });
  }

  if ($('.l-gallery_item__img').length > 0) {
    $('.l-gallery_item__img').each(function(){
      var self = $(this),
        src = (self.attr('src')).split(/preview_/);
      self.addClass('center-block')
        .wrap('<a class="l-gallery_item" href="'+src[0]+src[1]+'" target="_blank" rel="l-gallery"></a>');
    });
    $('.l-gallery_item').append('<i class="fa fa-search-plus fa-2"></i>');
  };

  if ($('.img-alt').length > 0) {
    $('.img-alt').each(function(){
      var self=$(this),
        advClass = '';

      if(self.hasClass('pull-right')){
        self.removeClass('pull-right');
        advClass='pull-right';
      };
      self.unwrap('p')
        .wrap('<div class="img-alt-wrap '+advClass+'" style="max-width:320px;"></div>')
        .after('<div class="img-alt_descr">'+self.attr('alt')+'</div>');

    });
  };

  if($('.insblock-adline').length > 0){
    $.get('/html/insblock/adline-ru.html?nocache='+ currDate.getDate())
      .done(function( data ) {
        $('.insblock-adline').html(data);
      });
  };

  if($('.insblock-adline-en').length > 0){
    $.get('/html/insblock/adline-en.html?nocache='+ currDate.getDate())
      .done(function( data ) {
        $('.insblock-adline-en').html(data);
      });
  };

  if( $('.insblock-products').length > 0 ){
    $.get('/html/insblock/products_cream.html?nocache='+ currDate.getDate())
      .done(function( data ) {
        $('.insblock-products._cream').html(data);
      });
  }

  if($('.insblock-ask-question').length > 0){
    var $askQuestionState = (sessionStorage.getItem('askQuestionState')) ? sessionStorage.getItem('askQuestionState') : null;
    console.log('$askQuestionState', $askQuestionState);
    if($askQuestionState !== 'hidden') {
      $.get('/html/insblock/ask-question-mobile.html')
        .done(function( data ) {
          $('.insblock-ask-question').html(data);
          $('.ask-question-mobile__cross').on('click', function(){
            $('.ask-question-mobile').fadeOut('slow');
            sessionStorage.setItem('askQuestionState', 'hidden');
          });
        });
    }
  }

  if($('.marquee').length > 0){
    $('.marquee').marquee({
      duration: 8000,
      gap: 18,
      delayBeforeStart: 0,
      duplicated: true
    });
  };

  if($('.carousel').length > 0){
    $('.carousel').carousel({
      interval: 4000
    });
  };

  if($('.required').length > 0){
    $('.required .form-control').prop('required', true);
  };

  if($('.landing').length > 0){
    var options = {
      target: '',
      beforeSubmit: showRequest,
      success: showResponse,
      url: $('.landing form').attr('action'),
      type: 'post',
      dataType: 'json',
      clearForm: true
    };
    $('.landing form').submit(function(){
      $(this).validate();
      $(this).ajaxSubmit(options);
      return false;
    });
  };

  if($('#order-losterin-form').length > 0){
    $("#order-losterin-form").validate();
    var
      quantityProd = parseInt($('#id_quantity').val()) || 0,
      totalPrice=parseInt($('.total-price .cost').data('price')) * quantityProd;
    $('.total-price .cost').html(totalPrice);

    if($('#id_quantity').val() == ''){
      $('#id_quantity').val(1).trigger('change');
      calcPrice($('#id_quantity'));
    }

    $('#id_quantity').on({
      keyup: function(){
        var self=$(this);
        calcPrice(self);
      },
      focus: function(){
        $(this).select();
      }
    });
  };

  if ( $('.__wheretobuy').length > 0 ) {
    var _pathname = document.location.pathname,
      _cookie = $.cookie( (document.location.pathname).split('/')[1] ) || false;

    var _wtbBtn = $('.__wheretobuy,.wheretobuy-tablist .tab-pane h4');
    _wtbBtn.on('click', function () {
      if( $('#listCity').length > 0 ) {
        $('#listCity').modal('show');
      }
    });

    if( _pathname == '/where-to-buy/' || _pathname == '/where-to-buy-kz/' || _pathname == '/where-to-buy-by/' ){
      // _wtbBtn.on('load',);
      _wtbBtn.trigger('click');
    }
  }

  if($('.preparates-adv a').length > 0){
    $('.preparates-adv a').on('click', function(){
      window.open(this.href);
      return false;
    });
  }

  if($('#id_name').length > 0){
    $('#id_name').prop('required', true);
  };
  if($('#id_email').length > 0){
    $('#id_email').prop('required', true);
  };
  if($('#id_feedback').length > 0){
    $('#id_feedback').prop('required', true);
  };
  if($('#id_review').length > 0){
    $('#id_review').prop('required', true);
  };

  if( $('.dropdown').length > 0 ){
    if ( window.innerWidth < 767 ) {
      $('.dropdown')
        .find('.dropdown-menu')
          .siblings('a[href="#"],.nav-link')
            .attr('data-toggle','dropdown');
      $('a[href="#"]').on('click',function(e){
        e.preventDefault();
        var _coord = $("#losterin-navbar-top-collapse").offset().top;
        console.log(_coord);
        return $([document.documentElement, document.body]).animate({
          scrollTop: _coord
        }, 100);
      });
    }
    $('.dropdown li').each(function(){
      var self = $(this);
      if(self.hasClass('active')){
        self.parents('.dropdown').addClass('active');
      };
    });
  }

  if($('.popular-articles').length > 0){
    var
      popartlist = $('.popular-articles_list'),
      popartlistHeight = popartlist.height(),
      popartlistItemsLength = popartlist.find('li').length,
      popartlistVisibleHeightElm = parseInt(popartlistHeight/popartlistItemsLength),
      popartlistVisibleHeight = parseInt( popartlistVisibleHeightElm * ( popartlist.find('li.cut').index() + .75) );
      popartlist.css({'height': popartlistVisibleHeight});
    $('.popular-articles_list_wrap .showhide i').on('click',function(){
      if(!$('.popular-articles_list_wrap').hasClass('full')){
        popartlist.animate({'height': (popartlistHeight + popartlistVisibleHeightElm)}, 500);
      } else {
        popartlist.animate({'height': popartlistVisibleHeight}, 500);
      };
      $('.popular-articles_list_wrap').toggleClass('full');
    })
  }

  /* Hidder */
  (function() {
    if( $('[data-toggle-id]').length > 0 ){
      $('[data-toggle-id]').each(function(){
        var self = $(this),
          defaultText = self.html();
          self.data('default-text', defaultText);
          self.data('active-text', '<strong>Скрыть все аптеки</strong> <i class="glyphicon glyphicon-chevron-up"></i>');
      });

      document.addEventListener("click", function(event) {
        var target = event.target;
        while (target !== this) {
          if (target.hasAttribute('data-toggle-id')) {
            event.preventDefault();
            $(target).toggleClass('active');
            var id = target.getAttribute('data-toggle-id'),
              elem = document.getElementById(id);
            $(elem).slideToggle('slow');
            if ( $(target).hasClass('active') ) {
              $(target).html( $(target).data('active-text') );
            } else {
              $(target).html( $(target).data('default-text') );
            };
            return;
          }
          target = target.parentNode;
        }
      });
    }
  })();

  /* Landings cells coloring */
  if ( $('.landing').length ){
    var
      columns = $('.landing-column'),
      columnsCount = columns.length,
      itemsCount = $('.landing-column-item').length,
      itemsPerCol = Math.round(itemsCount / columnsCount),
      colorThemes = 5,
      currentColor = 1;

    for (var rowCount = 0; rowCount < itemsPerCol; rowCount++) {
      for(var j = 0; j < columnsCount; j++) {
        var column = $(columns[j]),
          activeItem = $(column.children('.landing-column-item')[rowCount]);

        activeItem
          .css({'background-color': ''})
          .addClass( '_style-' + currentColor );

        currentColor++;
        if ( currentColor > colorThemes ) {
          currentColor = 1;
        }
      }
    }
  }
  /* END Landings cells coloring */

  // if ( $('.sharing').length > 0 ) {
  // 	(function() {var d = document, s = d.createElement('script'), g = 'getElementsByTagName'; s.type = 'text/javascript'; s.charset='UTF-8'; s.async = true; s.src = ('https:' == window.location.protocol ? 'https' : 'http')  + '://yastatic.net/es5-shims/0.0.2/es5-shims.min.js'; var h=d[g]('head')[0]; h.appendChild(s);
  // 	})();
  // 	(function() {var d = document, s = d.createElement('script'), g = 'getElementsByTagName'; s.type = 'text/javascript'; s.charset='UTF-8'; s.async = true; s.src = ('https:' == window.location.protocol ? 'https' : 'http')  + '://yastatic.net/share2/share.js'; var h=d[g]('head')[0]; h.appendChild(s);
  // 	})();
  // }
});

/* sticky meny */
(function() {
  if (window.innerWidth > 767) {
    var replaceElemToElem = function(elem) {
      var
        replaceDiv = document.createElement("div"),
        computedStyle = elem.currentStyle || getComputedStyle(elem, '');
      replaceDiv.style.height = elem.offsetHeight + "px"; replaceDiv.style.marginTop = computedStyle.marginTop;
      replaceDiv.style.marginBottom = computedStyle.marginBottom; replaceDiv.style.background = "transparent";
      elem.parentNode.insertBefore(replaceDiv, elem);
      return replaceDiv;
    }
    var
      nav = $(".navbar"),
      header = $("header"),
      row = $(".navbar-default .row-fluid"),
      replacer;
    $(window).on("scroll", function(e) {
      if ($(document).scrollTop() > Math.round(header.offset().top) + header.height()) {
        if (!nav.hasClass('fixed-top')) {
          nav.addClass('fixed-top');
          row.addClass('container');
          replacer = replaceElemToElem(nav[0]);
          /* console.log('down'); */
        }
      }
      else {
        if (nav.hasClass('fixed-top')) {
          nav.removeClass('fixed-top');
          row.removeClass('container');
          if (replacer) $(replacer).remove();
        }
      }
    });

    // $('.navbar .dropdown').each(function(){
    //   var _this = $(this),
    //     _dropdown = _this.find('[data-toggle="dropdown"]');
    //   _this.on({
    //     'mouseover': function(){
    //       _dropdown.dropdown('show');
    //     },
    //     'mouseleave': function(){
    //       _dropdown.dropdown('hide');
    //     }
    //   });
    // });

    if( $('.dropdown').length > 0 ){
      if ( window.innerWidth < 767 ) {
        $('.dropdown').find('.dropdown-menu').siblings('a[href="#"],.nav-link').attr('data-toggle','dropdown');
        $('a[href="#"]').on('click', function(e){
          e.preventDefault();
          var _coord = $("#losterin-navbar-top-collapse").offset().top;
          console.log(_coord);
          return $([document.documentElement, document.body]).animate({
            scrollTop: _coord
          }, 100);
        });
      }
      $('.dropdown li').each(function(){
        var self = $(this);
        if(self.hasClass('active')){
          self.parents('.dropdown').addClass('active');
        };
      });
    }
  }

  // Залипание блока с вопросами на десктопе
  // if ( window.innerWidth > 991 ) {
  // 	$(window).scroll(function() {
  // 		var askQuestion = $('.ask-question'),
  // 				scrollTop = parseInt($(window).scrollTop()),
  // 				askQuestionArea = parseInt($('footer').offset().top) - scrollTop,
  // 				askQuestionIndents = $('nav.fixed-top').outerHeight() + parseInt($('main').css('padding-bottom')),
  // 				askQuestionMinArea = askQuestion.outerHeight() + askQuestionIndents;

  // 		if (scrollTop > $('header').outerHeight() && askQuestionArea >= askQuestionMinArea) {
  // 			askQuestion.removeClass('affix-bottom');
  // 			askQuestion.addClass('affix');
  // 		} else if (askQuestionArea < askQuestionMinArea) {
  // 			askQuestion.removeClass('affix');
  // 			askQuestion.addClass('affix-bottom');
  // 		} else {
  // 			askQuestion.removeClass('affix-bottom affix');
  // 		}
  // 	});
  // }

}());

/* mobile navigation */
// (function () {
// 	var body = document.querySelector('body');
// 	var burger = document.querySelector('.navbar-toggle');
// 	burger.addEventListener('click', function () {
// 		body.classList.toggle('overflow-hidden');
// 	});
// })();